/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconEaseOut = createReactComponent("ease-out", "IconEaseOut", [
  ["path", { d: "M3 20s10 -16 18 -16", key: "svg-0" }]
]);

export { IconEaseOut as default };
//# sourceMappingURL=IconEaseOut.js.map
